// src/components/Whatsapp/componentes/VideoModal.jsx

import React from 'react';

export const VideoModal = ({ videoUrl, onClose }) => {
  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
    >
      <div className="relative" onClick={(e) => e.stopPropagation()}>
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 bg-white rounded-full p-1 text-black z-10"
          aria-label="Cerrar video"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <video
          src={videoUrl}
          controls    // Muestra los controles de play, volumen, etc.
          autoPlay    // El video empieza a reproducirse al abrir el modal
          muted       // Empieza sin sonido (buena práctica para autoplay)
          className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-2xl"
        >
          Tu navegador no soporta la etiqueta de video.
        </video>
      </div>
    </div>
  );
};